// Deeproot quest target locations (world XZ).
export const DEEPROOT_TOWN_CENTER = { x: 680, z: -6000 };

// Root-keeper talk spot — placed in a more open patch of the plaza so the
// player can always reach it (even with dense collision).
export const DEEPROOT_ROOTKEEPER_SPOT = { x: 664, z: -5982 };
export const DEEPROOT_ROOTKEEPER_R = 8.0;

// These match the pinned villager posts in TownNPCs.js (slot 0..2).
export const DEEPROOT_VILLAGER_POSTS = [
  { x: 670, z: -5992 },
  { x: 694, z: -6006 },
  { x: 676, z: -6014 },
];

// Journal search spot. Intentionally near the plaza so it's easy to find.
export const DEEPROOT_JOURNAL_SPOT = { x: 682, z: -6026 };
export const DEEPROOT_JOURNAL_R = 7.0;

